/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientOnboardingModel } from '../../models/patient-onboarding-model';

export interface PatientOnboardingSearchIdNumberGet$Params {
  idNumber: string;
}

export function patientOnboardingSearchIdNumberGet(http: HttpClient, rootUrl: string, params: PatientOnboardingSearchIdNumberGet$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<PatientOnboardingModel>> {
  const rb = new RequestBuilder(rootUrl, patientOnboardingSearchIdNumberGet.PATH, 'get');
  if (params) {
    rb.path('idNumber', params.idNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<PatientOnboardingModel>;
    })
  );
}

patientOnboardingSearchIdNumberGet.PATH = '/PatientOnboarding/search/{idNumber}';
